<template>
  <div class="app-container">
    <!-- begin app-main -->
    <div class="app-main" id="main">
      <!-- begin container-fluid -->
      <div class="container-fluid">
        <!-- begin row -->
        <div class="row">
          <div class="col-md-12 m-b-30">
            <!-- begin page title -->
            <div class="d-block d-sm-flex flex-nowrap align-items-center">
              <div class="page-title mb-2 mb-sm-0">
                <h1>Cinema</h1>
              </div>
              <div class="ml-auto d-flex align-items-center">
                <nav>
                  <ol class="breadcrumb p-0 m-b-0">
                    <li class="breadcrumb-item">
                      <a >
                        <i class="ti ti-home"></i>
                      </a>
                    </li>
                    <li class="breadcrumb-item">Cinema</li>
                  </ol>
                </nav>
              </div>
            </div>
            <!-- end page title -->
          </div>
        </div>
        <!-- end row -->
        <div
          class="modal fade"
          id="createModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="createModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Create Cinema</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form>
                  <div class="form-group">
                    <label>Image</label>
                    <input
                      type="file"
                      id="myFile"
                      @click="encodeFile"
                      @change="encodeFile"
                      class="form-control"
                    />
                  </div>
                  <div class="form-group">
                    <label>Name</label>
                    <input type="text" class="form-control" v-model="editCinema.name" />
                  </div>
                   <div class="form-group">
                    <label>Email</label>
                    <input type="email" class="form-control" v-model="editCinema.email" />
                  </div>

                   <div class="form-group">
                    <label>Address</label>
                    <input type="text" class="form-control" v-model="editCinema.address" />
                  </div>
                  
                  <div class="form-group">
                    <label>State</label>
                    <select class="form-control" v-model="editCinema.state_id">
                      <option>Select State</option>
                      <option
                        :value="state.id"
                        v-for="(state,index) in states"
                        :key="index"
                        :selected="(state.id == editCinema.state_id)? 'selected' : ''"
                      >{{state.name}}</option>
                    </select>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button
                  type="button"
                  @click="createCinema();"
                  class="btn btn-primary"
                  data-dismiss="modal"
                >Save changes</button>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal -->
        <div
          class="modal fade"
          id="editModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="editModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Edit Cinema</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form>
                  <div class="form-group">
                    <label>Image</label>
                    <input
                      type="file"
                      id="myFile"
                      @click="encodeFile"
                      @change="encodeFile"
                      class="form-control"
                    />
                  </div>
                  <div class="form-group">
                    <label>Name</label>
                    <input type="text" class="form-control" v-model="editCinema.name" />
                  </div>
                  <div class="form-group">
                    <label>Email</label>
                    <input type="email" class="form-control" v-model="editCinema.email" />
                  </div>

                  <div class="form-group">
                    <label>Address</label>
                    <input type="text" class="form-control" v-model="editCinema.address" />
                  </div>

                  <div class="form-group">
                    <label>State</label>
                    <select class="form-control" v-model="editCinema.state_id">
                      <option>Select State</option>
                      <option
                        :value="state.id"
                        v-for="(state,index) in states"
                        :key="index"
                        :selected="(state.id == editCinema.state_id)? 'selected' : ''"
                      >{{state.name}}</option>
                    </select>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button
                  type="button"
                  @click="updateCinema();"
                  class="btn btn-primary"
                  data-dismiss="modal"
                >Save changes</button>
              </div>
            </div>
          </div>
        </div>
        <!-- begin row -->
        <div class="row">
          <div class="col-lg-12">
            <Loader v-if="$store.getters.isLoading" />
            <div v-else class="card card-statistics">
              <div class="card-body">
                <Loader v-if="$store.getters.isLoading" />
                <div v-else class="export-table-wrapper table-responsive">
                  <div class="export-buttons m-b-20 row">
                    <a
                      href="#"
                      id="exportExcel"
                      class="btn btn-primary col-2"
                      @click.prevent="editCinema = {}"
                      data-toggle="modal"
                      data-target="#createModal"
                    >Create Cinema</a>
                    <div class="col-1"></div>

                     <select
                      v-model="state"
                      @change="getCinemas()"
                      class="form-control col-2"
                    >
                      <option value="all">All States</option>
                      <option
                        v-for="(state,index) in states"
                        :key="index"
                        :value="state.id"
                      >{{ state.name | capitalize }}</option>
                    </select>


                  </div>
                  <table id="export-table" class="table table-bordered">
                    <thead class="thead-light">
                      <tr>
                        <th>Image</th>
                        <th>Name</th>
                         <th>Email</th>
                        <th>State</th>
                        <th>Address</th>
                        <th></th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <span v-if="cinemas.length < 1">No Cinema Found</span>
                      <tr v-for="(cinema,index) in cinemas" :key="index">
                        <td>
                          <img
                            :src="cinema.image"
                            class="profile-image"
                            style="width: 50px; height: 50px;"
                            alt="LOGO"
                          />
                        </td>
                        <td>{{cinema.name}}</td>
                          <td>{{cinema.email}}</td>
                        <td>{{cinema.state.name}}</td>
                         <td>{{cinema.address}}</td>
                        <td>
                          <button
                            class="btn btn-secondary mr-5"
                            @click.prevent="editing = true; prepEdit(cinema)"
                            data-toggle="modal"
                            data-target="#editModal"
                          >&#9998;</button>
                             </td>
                             <td>
                          <button
                            class="btn btn-danger"
                            @click.prevent="deleteCinema(cinema.id,index)"
                          >🗑</button>
                             </td>
                     
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end row -->
      </div>
      <!-- end container-fluid -->
    </div>
    <!-- end app-main -->
  </div>
</template>

<script>
import Swal from "sweetalert2";
import Loader from "../../components/Loader.vue";
export default {
  data() {
    return {
      cinemas: [],
      states: [],
      editing: false,
      state: "all",
      currentPage: 1,
      editCinema: {}
    };
  },
  components: {
    Loader
  },
  mounted() {
    this.getCinemas();
    this.getStates();
  },
  methods: {
    encodeFile(e) {

      let file = e.target.files[0];
        if(!file) return;

      let reader = new FileReader();
      reader.onloadend = () => {
        this.editCinema.image = reader.result;
      };
      reader.readAsDataURL(file);
    },
    prepEdit(cinema) {
      this.editCinema = {...cinema};
      this.editCinema.image = null;
    },
    getCinemas() {
      this.$store.commit("setLoading", true);
      fetch(this.$store.getters.baseURL + `movies/cinemas/${this.state}/all`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.$store.getters.getToken
        }
      })
        .then(res => res.json())
        .then(result => {
          console.log(result);
          if (result.status) {
            this.cinemas = result.data.data;
          } else {
            Swal.fire({
              icon: "error",
              title: result.message
            });
          }
          this.$store.commit("setLoading", false);
        })
        .catch(err => {
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Check your connection"
          });
          this.$store.commit("setLoading", false);
        });
    },
    deleteCinema(id, index) {
      const link =
        this.$store.getters.baseURL + "movies/cinemas/" + id + "/destroy";

      Swal.queue([
        {
          icon: "warning",
          title: "Delete cinema?",
          confirmButtonText: "Confirm Delete!",
          showCancelButton: true,
          text: "This action is irreversible and can break the system",
          showLoaderOnConfirm: true,
          preConfirm: () => {
            return fetch(link, {
              method: "DELETE",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + this.$store.getters.getToken
              }
            })
              .then(response => response.json())
              .then(result => {
                if (result.status) {
                  Swal.insertQueueStep({
                    icon: "success",
                    title: result.message
                  });
                  this.cinemas.splice(index, 1);
                } else {
                  Swal.insertQueueStep({
                    icon: "error",
                    title: result.message
                  });
                }
              })
              .catch(() => {
                Swal.insertQueueStep({
                  icon: "error",
                  title: "Some thing went wrong",
                  text: "Check your internet connection"
                });
              });
          }
        }
      ]);
    },
    getStates() {
      fetch(this.$store.getters.baseURL + "states/admin/all", {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.$store.getters.getToken
        }
      })
        .then(res => res.json())
        .then(result => {
          console.log(result);
          if (result.status) {
            this.states = result.data;
          } else {
            Swal.fire({
              icon: "error",
              title: result.message
            });
          }
          this.$store.commit("setLoading", false);
        })
        .catch(err => {
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Check your connection"
          });
          this.$store.commit("setLoading", false);
        });
    },

    updateCinema() {
      this.$store.commit("setLoading", true);
      fetch(
        this.$store.getters.baseURL +
          "movies/cinemas/" +
          this.editCinema.id +
          "/update",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.$store.getters.getToken
          },
          body: JSON.stringify(this.editCinema)
        }
      )
        .then(res => res.json())
        .then(result => {
          console.log(result);
          if (result.status) {
            let restaurantIndex = this.cinemas.findIndex(cinema => {
              if (cinema.id == this.editCinema.id) return true;
            });
            this.cinemas[restaurantIndex] = result.data;
          } else {
            Swal.fire({
              icon: "error",
              title: result.message
            });
          }
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Check your connection"
          });
          this.$store.commit("setLoading", false);
        });
    },

    createCinema() {
      this.$store.commit("setLoading", true);
      fetch(this.$store.getters.baseURL + "movies/cinemas/create", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.$store.getters.getToken
        },
        body: JSON.stringify(this.editCinema)
      })
        .then(res => res.json())
        .then(result => {
          console.log(result);
          if (result.status) {
            this.cinemas = [result.data, ...this.cinemas];
          } else {
            Swal.fire({
              icon: "error",
              title: result.message
            });
          }
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Check your connection"
          });
          this.$store.commit("setLoading", false);
        });
    }
  }
};
</script>

<style scoped></style>
